import { useEffect } from 'react';
import { useForm } from 'react-final-form';

import { useOrderStore } from '@blocks/stores/order';

export default () => {
  const { order } = useOrderStore();
  const { mutators } = useForm();

  const {
    login,
    paper_type,
    pages_qty,
    words_qty,
    deadline_datetime,
    writer_req_slug,
    title,
    ...rest
  } = order;

  useEffect(() => {
    if (login) {
      mutators.applyLogin(login);
    }
  }, [login]);

  useEffect(() => {
    if (paper_type) {
      mutators.applyPaperType(paper_type);
    }
  }, [paper_type]);

  useEffect(() => {
    if (pages_qty) {
      mutators.applyPages(pages_qty);
    }
  }, [pages_qty]);

  useEffect(() => {
    if (words_qty) {
      mutators.applyWords(words_qty);
    }
  }, [words_qty]);

  useEffect(() => {
    if (rest['paper-size-type']) {
      mutators.applyPaperSizeType(rest['paper-size-type']);
    }
  }, [rest['paper-size-type']]);

  useEffect(() => {
    if (deadline_datetime) {
      mutators.applyDeadline(deadline_datetime);
    }
  }, [deadline_datetime]);

  useEffect(() => {
    if (writer_req_slug) {
      mutators.requestWriter(writer_req_slug);
    } else {
      mutators.removeWriter();
    }
  }, [writer_req_slug]);

  useEffect(() => {
    if (title) {
      mutators.applyTitle(title);
    } else {
      mutators.removeTitle();
    }
  }, [title]);

  return null;
};
